'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { getContentModelId, getTemplatePath, getPreviewKey } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getTemplateLabel, getHasTemplate, getIsRestorableTemplate } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import ContentRoutes from 'ContentUtils/Routes';
import ForceTemplateSwapModal from 'ContentEditorUI/components/modals/ForceTemplateSwapModal';
import TemplateSelectModal from 'ContentEditorUI/components/modals/TemplateSelectModal';
import { getHasModulesInFlexColumn } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { connect } from 'react-redux';
import { bindAll } from 'underscore';
import { fetchTemplateInfo, handleRestoreMissingTemplate } from 'ContentEditorUI/redux/actions/templateInfoActions';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  isMissingTemplate: !getHasTemplate(state),
  messageKey: getTemplatePath(state) ? getTemplateLabel(state) ? 'deletedTemplateMessage' : 'deletedTemplateNoLabelMessage' : 'noTemplateMessage',
  templatePath: getTemplatePath(state),
  contentId: getContentModelId(state),
  hasModulesInFlexColumn: getHasModulesInFlexColumn(state),
  shouldShowRestore: getIsRestorableTemplate(state),
  previewKey: getPreviewKey(state)
});
class TemplateExistenceCheckContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showForceTemplateSwampModal: props.isMissingTemplate,
      showTemplateSelectModal: false
    };
    bindAll(this, 'onConfirm', 'closeTemplateSelectModal');
  }
  componentDidMount() {
    if (this.props.isMissingTemplate) {
      this.props.fetchTemplateInfo(this.props.templatePath);
    }
  }
  onConfirm() {
    this.setState({
      showForceTemplateSwampModal: false
    });
    const {
      contentType,
      contentId
    } = this.props;
    if (contentType === 'email') {
      this.setState({
        showTemplateSelectModal: true
      });
    } else {
      window.location.href = ContentRoutes.templateSwap(contentType, contentId);
    }
  }
  closeTemplateSelectModal() {
    const {
      cancelRedirectUrl
    } = this.props;
    window.location = cancelRedirectUrl;
  }
  render() {
    const {
      messageKey,
      hasModulesInFlexColumn,
      children,
      isCustomTemplateWithFlexArea,
      shouldShowRestore,
      contentType,
      contentId,
      previewKey
    } = this.props;
    const {
      showForceTemplateSwampModal,
      showTemplateSelectModal
    } = this.state;
    if (showForceTemplateSwampModal) {
      return /*#__PURE__*/_jsx(ForceTemplateSwapModal, {
        onConfirm: this.onConfirm,
        messageKey: messageKey,
        hasModulesInFlexColumn: hasModulesInFlexColumn,
        shouldShowRestore: shouldShowRestore,
        onRestore: this.props.handleRestoreMissingTemplate,
        hasDndArea: isCustomTemplateWithFlexArea
      });
    }
    if (showTemplateSelectModal) {
      return /*#__PURE__*/_jsx(TemplateSelectModal, {
        contentType: contentType,
        contentId: contentId,
        onClose: this.closeTemplateSelectModal,
        previewKey: previewKey,
        hasDndArea: isCustomTemplateWithFlexArea
      });
    }
    if (children) {
      return children;
    }
    return null;
  }
}
TemplateExistenceCheckContainer.propTypes = {
  cancelRedirectUrl: (props, propName) => {
    if (props['contentType'] === 'email' && (props[propName] == null || typeof props[propName] !== 'string')) {
      return new Error('The cancelRedirectUrl prop is required when contentType === email');
    }
    return undefined;
  },
  children: PropTypes.node,
  contentId: PropTypes.number.isRequired,
  contentType: PropTypes.string.isRequired,
  fetchTemplateInfo: PropTypes.func.isRequired,
  handleRestoreMissingTemplate: PropTypes.func.isRequired,
  hasModulesInFlexColumn: PropTypes.bool.isRequired,
  isCustomTemplateWithFlexArea: PropTypes.bool,
  isMissingTemplate: PropTypes.bool.isRequired,
  messageKey: PropTypes.string.isRequired,
  previewKey: PropTypes.string,
  shouldShowRestore: PropTypes.bool.isRequired,
  templatePath: PropTypes.string.isRequired
};
export default connect(mapStateToProps, {
  handleRestoreMissingTemplate,
  fetchTemplateInfo
})(TemplateExistenceCheckContainer);